import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from "@angular/router";

import { ListInfo } from './shared/list-info';
import { PageDataItem } from "./../../../shared/models/activeSearch";
import { AppSettingsService } from 'app/shared/services/app-settings.service';


@Component({
  selector: 'app-directory-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class DirectoryListComponent implements OnInit {
  @Input() listInfo: ListInfo;
  @Input() hideAddress: boolean;

  @Output() pageClick: EventEmitter<any> = new EventEmitter();

  isExpirationDateLessThanToday = true;
  currentDate = new Date;
  onShowAddressClick(item: PageDataItem) {
    item.showAddress = !item.showAddress;
  }
  
  baseCredential(item, cred) {
    const x = item;
    if(cred == "ACCS" || cred=="NPS" || cred=="SDS") {
      if(!item || item.length==0) {
        return "";
      } else {
        return item[0].baseCredentialCode+"-";
      } 
    } 
    return "";
  }

  get pageCount(): number {
    return Math.ceil(this.listInfo.totalRecords / this.listInfo.pageLimit);
  }

  constructor(private appSettings: AppSettingsService,
              private router: Router
  ) { }

  ngOnInit() {
            
  }

  orderCV(i) {
    this.router.navigate([
      "/directory/purchase", i.personId, i.firstName + " " + i.lastName,
    ]);
  }

  printSection(divId: string) {     
    this.currentDate = new Date;   
    const printDivCSS = new String ('<style>.no-print{display:none;}.red{color:red;}.on-print{display:block!important;}.image-print{display:initial!important}</style><div style="display:flex;justify-content:center;"><img class="on-print center" style="width:125px; height: auto" id="image" src="/assets/images/logo.png" alt="NBRC logo" /></div>');
    window.frames["print_frame"].document.body.innerHTML=printDivCSS + document.getElementById(divId).innerHTML;
    
    window.frames["print_frame"].window.focus();
    window.frames["print_frame"].window.print();       
  }

  pageChanged(targetPage: number) {
    this.listInfo.setPageNumber(targetPage);
    this.pageClick.emit(targetPage);
  }
}
